import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TaskinstanceDashboard from '../TaskinstanceDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function TaskinstancePage() {
    const dispatch = useDispatch();
    const { TaskinstanceList} = useSelector((state)=>state.manufaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < TaskinstanceDashboard />
    )

}